export const enum KEYS {
  C = 'C',
  V = 'V',
  X = 'X',
  Z = 'Z',
  Y = 'Y',
  A = 'A',
  G = 'G',
  L = 'L',
  F = 'F',
  D = 'D',
  B = 'B',
  P = 'P',
  R = 'R',
  MINUS = '-',
  EQUAL = '=',
  DELETE = 'DELETE',
  UP = 'ARROWUP',
  DOWN = 'ARROWDOWN',
  LEFT = 'ARROWLEFT',
  RIGHT = 'ARROWRIGHT',
  ENTER = 'ENTER',
  SPACE = ' ',
  TAB = 'TAB',
  BACKSPACE = 'BACKSPACE',
  ESC = 'ESCAPE',
  PAGEUP = 'PAGEUP',
  PAGEDOWN = 'PAGEDOWN',
  F5 = 'F5',
}

export const HOTKEY_DOC = [
  {
    type: 'General',
    children: [
      { label: 'Cut', value: 'Ctrl + X' },
      { label: 'Copy', value: 'Ctrl + C' },
      { label: 'Paste', value: 'Ctrl + V' },
      // { label: 'Quick CopyPaste', value: 'Ctrl + D' },
      { label: 'Select All', value: 'Ctrl + A' },
      { label: 'Undo', value: 'Ctrl + Z' },
      { label: 'Redo', value: 'Ctrl + Y' },
      { label: 'Delete', value: 'Delete / Backspace' },
      { label: 'Multiple Selection', value: 'Press and hold Ctrl or Shift' },
      { label: 'Print', value: 'Ctrl + P' },
      { label: 'Close', value: 'ESC' },
    ],
  },
  {
    type: 'Page Preview',
    children: [
      { label: 'Preview from First Page', value: 'F5' },
      { label: 'Preview from Current Page', value: 'Shift + F5' },
      { label: 'Switch to Previous Page', value: '↑ / ← / PgUp' },
      { label: 'Switch to Next Page', value: '↓ / → / PgDown' },
      { label: 'Switch to Next Page', value: 'Enter / Space' },
      { label: 'Exit Preview', value: 'ESC' },
    ],
  },
  {
    type: 'Page Editing',
    children: [
      { label: 'Create New Page', value: 'Enter' },
      { label: 'Move Canvas', value: 'Space + Mouse Drag' },
      { label: 'Zoom Canvas', value: 'Ctrl + Mouse Wheel' },
      { label: 'Zoom In Canvas', value: 'Ctrl + =' },
      { label: 'Zoom Out Canvas', value: 'Ctrl + -' },
      { label: 'Fit to Screen', value: 'Ctrl + 0' },
      { label: 'Previous Page (No Element Selected)', value: '↑ / ←' },
      { label: 'Next Page (No Element Selected)', value: '↓ / →' },
      { label: 'Previous Page', value: 'Mouse Scroll Up / PgUp' },
      { label: 'Next Page', value: 'Mouse Scroll Down / PgDown' },
    ],
  },
  {
    type: 'Element Operations',
    children: [
      { label: 'Move', value: '↑ / ← / ↓ / →' },
      { label: 'Lock', value: 'Ctrl + L' },
      { label: 'Group', value: 'Ctrl + G' },
      { label: 'Ungroup', value: 'Ctrl + Shift + G' },
      { label: 'Bring to Front', value: 'Alt + F' },
      { label: 'Send to Back', value: 'Alt + B' },
      { label: 'Lock Aspect Ratio', value: 'Press and hold Ctrl or Shift' },
      { label: 'Create Horizontal / Vertical Lines', value: 'Press and hold Ctrl or Shift' },
      { label: 'Switch Focus Element', value: 'Tab' },
      { label: 'Confirm Image Crop', value: 'Enter' },
    ],
  },
  {
    type: 'Table Editing',
    children: [
      { label: 'Focus on Next Cell', value: 'Tab' },
      { label: 'Insert Row Above', value: 'Ctrl + ↑' },
      { label: 'Insert Row Below', value: 'Ctrl + ↓' },
      { label: 'Insert Column Left', value: 'Ctrl + ←' },
      { label: 'Insert Column Right', value: 'Ctrl + →' },
    ],
  },
  // {
  //   type: 'Chart Data Editing',
  //   children: [
  //     { label: 'Focus on Next Row', value: 'Enter' },
  //   ],
  // },
  {
    type: 'Text Editing',
    children: [
      { label: 'Bold', value: 'Ctrl + B' },
      { label: 'Italic', value: 'Ctrl + I' },
      { label: 'Underline', value: 'Ctrl + U' },
      { label: 'Strikethrough', value: 'Ctrl + D' },
    ],
  },
]
